export const BILLING_MASTER_ITEMS_LOADED = 'BILLING_MASTER_ITEMS_LOADED';
export const BILLING_OPERATORS_LOADED = 'BILLING_OPERATORS_LOADED';
export const BILLING_OPERATOR_ITEMS_LOADED = 'BILLING_OPERATOR_ITEMS_LOADED';
export const BILLING_REVIEW_ITEMS_LOADED = 'BILLING_REVIEW_ITEMS_LOADED';
export const BILLING_ACTIVITY_LOGS_LOADED = 'BILLING_ACTIVITY_LOGS_LOADED';